import { NskHead } from "~/components/common/head/NskHead";
import { Page as AdminComponent } from "~/containers/specifics/admin/Page";
import { Page as Component } from "~/containers/specifics/home/Page";
import useItandiAccount from "~/hooks/useItandiAccount";

export const PATH = "/";

function Home() {
	const { data: account } = useItandiAccount().currentAccount();
	if (account === null) {
		return null;
	}
	if (account.isAdmin && account.company === null) {
		return (
			<>
				<NskHead title="管理者ページ" />
				<AdminComponent />
			</>
		);
	}
	return (
		<>
			<NskHead title="ダッシュボード" />
			<Component account={account} />
		</>
	);
}

export default Home;
